import { render, staticRenderFns } from "./TwoValueComparison.vue?vue&type=template&id=eafb84c4&"
import script from "./TwoValueComparison.vue?vue&type=script&lang=ts&"
export * from "./TwoValueComparison.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports